module.exports = __webpack_public_path__ + "static/img/bgs.38e179c3.png";